import { styled } from "@mui/material/styles";

export const FlexCenter = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
}));

export const FlexColumnSB = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
}));

export const FlexRowSB = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
}));

export const FlexRowSA = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "space-around",
}));

export const FlexLeftCenter = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
}));

export const FlexColumnCenter = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
}));

export const FlexCenterTop = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
}));

export const FlexRowEnd = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "flex-end",
}));
